module.exports = __webpack_public_path__ + "media/images/drone-233a263c96a3112f5086ee1716521e36.svg";